import moment from 'moment-timezone';

export class ViewEnterpriseDashboardPerformanceLocationMonth {
	public id: number;
	public originContractId: string;
	public contractId: string;
	public originContractLocationId: string;
	public contractLocationId: string;
	public enterpriseId: number;
	public contractNum: string;
	public originContractNum: string;
	public productId: string;
	public productName: string;
	public supplierId: string;
	public supplierName: string;
	public serviceTypeId: string;
	public locationAddress1: string;
	public locationAddress2: string;
	public locationCity: string;
	public locationStateShort: string;
	public locationZipCode: string;
	public date: Date;
	public contractBaseRate: number;
	public usage: number;
	public hedgedUsage: number;
	public supplyRate: number;
	public supplyCost: number;
	public utilityRate: number;
	public utilityCost: number;
	public costAvoidance: number;
	public costAvoidancePercentage: number;
	public isUsageEstimated: boolean;
	public isSupplyRateEstimated: boolean;
	public isSupplyCostEstimated: boolean;
	public isUtilityRateEstimated: boolean;
	public isUtilityCostEstimated: boolean;
	public isCostAvoidanceEstimated: boolean;

	constructor(viewEnterpriseDashboardPerformanceLocationMonth: ViewEnterpriseDashboardPerformanceLocationMonth) {
		Object.assign(this, viewEnterpriseDashboardPerformanceLocationMonth);

		this.date = this.date ? new Date(moment(this.date).format('MMM DD, YYYY hh:mm:ss a')) : this.date;
	}
}
